import React, { Component } from "react";
import onClickOutside from "react-onclickoutside";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { NavLink } from "react-router-dom";
import classnames from "classnames";
import styled from 'styled-components';

import LogoW from './LogoW';

import * as userActions from "../../actions/userActions";
import * as shopActions from "../../actions/shopActions";

import {
  px,
  colors,
  founders,
  roboto,
  trirong,
} from '../Common/style';

import NavLogo from "./NavLogo";
import CreateNavLogo from "./CreateNavLogo";
import Cart from "../Cart";

const ProTag = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${colors.safetyLemon};
  padding: ${px(4)} ${px(6)};
  border-radius: ${px(4)};
  font-size: ${px(12)};
  font-weight: 600;
  margin-left: ${px(6)};
`;

// Here we are making GlobalNav a named export
// so that we can import the unconnected component
// for testing
export class GlobalNav extends Component {
  componentDidMount() {}

  handleClickOutside(e) {
    if (this.props.navbarDropdownVisible) {
      this.props.hideNavbarDropdown();
    }
  }

  render() {
    return (
      <nav
        className={classnames({
          "navbar globalnav": true,
          create: this.props.create
        })}
      >
        <div
          className={classnames({
            "navbar-brand": true,
            "is-hidden-desktop": !this.props.create
          })}
        >
          <div className={"navbar-item"}>
            {this.props.create ? <CreateNavLogo /> : <NavLogo />}

            {this.props.create && this.props.hasPro && <ProTag><LogoW />PRO</ProTag>}
          </div>

          <div className={"navbar-item navbar-cart"}>
            <Cart />
          </div>

          <div
            className={classnames({
              "navbar-burger burger": true,
              "is-active": this.props.navbarDropdownVisible,
              show: this.props.create
            })}
            onClick={() => this.props.toggleNavbarDropdown()}
          >
            <span />
            <span />
            <span />
          </div>
        </div>

        <div
          className={classnames({
            "navbar-menu": true,
            create: this.props.create,
            "is-active": this.props.navbarDropdownVisible
          })}
        >
          {/* Make dropdown */}
          <div
            className={classnames({
              "navbar-item": true,
              "navbar-create-dropdown": this.props.create,
              "nav-link text-right has-dropdown is-hoverable": !this.props.create
            })}
          >
            <div
              className={classnames({
                "navbar-hr-divider invis": true,
                "is-hidden-desktop": !this.props.create
              })}
            />

            <a
              className={classnames({
                "globalnav__link navbar-link navbar-dropdown-category": true,
                small: this.props.create
              })}
            >
              {"Make"}
            </a>

            <div
              className={classnames({
                "navbar-dropdown left": !this.props.create
              })}
            >
              {/* Create */}
              <div className={"navbar-item nav-link text-left"}>
                <NavLink
                  className={"globalnav__link list-item"}
                  activeClassName={"globalnav--active"}
                  to={"/create"}
                  onClick={() => this.props.hideNavbarDropdown()}
                >
                  {"Weft Create"}
                </NavLink>
              </div>

              {/* Remix */}
              <div className={"navbar-item nav-link text-left"}>
                <NavLink
                  className={"globalnav__link list-item"}
                  activeClassName={"globalnav--active"}
                  to={"/remix"}
                  onClick={() => this.props.hideNavbarDropdown()}
                >
                  {"Weft Remix"}
                </NavLink>
              </div>

              {/* Pro */}
              <div className={"navbar-item nav-link text-left"}>
                <NavLink
                  className={"globalnav__link list-item"}
                  activeClassName={"globalnav--active"}
                  to={"/weft-pro"}
                  onClick={() => this.props.hideNavbarDropdown()}
                >
                  {"Weft Pro"}<span>NEW!</span>
                </NavLink>
              </div>

            {/* About */}
            {/* <div className={"navbar-item nav-link text-left"}>
              <NavLink
                className={"globalnav__link list-item"}
                activeClassName={"globalnav--active"}
                to={"/about"}
                onClick={() => this.props.hideNavbarDropdown()}
              >
                {"About Weft"}
              </NavLink>
            </div> */}

              {/* How it Works */}
              {/* <div className={"navbar-item nav-link text-left"}>
                <NavLink
                  className={"globalnav__link list-item"}
                  activeClassName={"globalnav--active"}
                  to={"/how"}
                  onClick={() => this.props.hideNavbarDropdown()}
                >
                  {"How it Works"}
                </NavLink>
              </div> */}

              {/* Tutorials */}
              <div className={"navbar-item nav-link text-left"}>
                <NavLink
                  className={"globalnav__link list-item"}
                  activeClassName={"globalnav--active"}
                  to={"/tutorials"}
                  onClick={() => this.props.hideNavbarDropdown()}
                >
                  {"Tutorials"}
                </NavLink>
              </div>

              {/* FAQs */}
              <div className={"navbar-item nav-link text-left"}>
                <NavLink
                  className={"globalnav__link list-item"}
                  activeClassName={"globalnav--active"}
                  to={"/faq"}
                  onClick={() => this.props.hideNavbarDropdown()}
                >
                  {"FAQs"}
                </NavLink>
              </div>

              <div className="navbar-hr-divider invis is-hidden-desktop" />
            </div>
          </div>

          <div className={"navbar-item filler is-hidden-touch"} />


          {/* Shop dropdown */}
          <div
            className={classnames({
              "navbar-item": true,
              "navbar-create-dropdown": this.props.create,
              "nav-link text-left has-dropdown is-hoverable": !this.props.create
            })}
          >
            <div
              className={classnames({
                "navbar-hr-divider invis": true,
                "is-hidden-desktop": !this.props.create
              })}
            />

            <a
              href="/shop"
              className={classnames({
                "globalnav__link navbar-link navbar-dropdown-category": true,
                small: this.props.create
              })}
            >
              {"Shop"}
            </a>

            <div
              className={classnames({
                "navbar-dropdown right": !this.props.create
              })}
            >
              {/* Collabs */}
              <div className={"navbar-item nav-link text-left"}>
                <NavLink
                  className={"globalnav__link list-item"}
                  activeClassName={"globalnav--active"}
                  to={"/collabs"}
                  onClick={() => this.props.hideNavbarDropdown()}
                >
                  {"Collabs"}
                </NavLink>
              </div>

              {/* Essentials */}
              <div className={"navbar-item nav-link text-left"}>
                <NavLink
                  className={"globalnav__link list-item"}
                  activeClassName={"globalnav--active"}
                  to={"/shop"}
                  onClick={() => this.props.hideNavbarDropdown()}
                >
                  {"Patterns & Plains"}
                </NavLink>
              </div>

              {/* Sample packs */}
              <div className={"navbar-item nav-link text-left"}>
                <NavLink
                  className={"globalnav__link list-item"}
                  activeClassName={"globalnav--active"}
                  to={"/shop/product/1"}
                  onClick={() => this.props.hideNavbarDropdown()}
                >
                  {"Sample Packs"}
                </NavLink>
              </div>

              {/* Symmetry */}
              {/* <div className={"navbar-item nav-link text-left"}>
                <NavLink
                  className={"globalnav__link list-item"}
                  activeClassName={"globalnav--active"}
                  to={"/symmetry"}
                  onClick={() => this.props.hideNavbarDropdown()}
                >
                  {"Symmetry™ Program"}
                </NavLink>
              </div> */}

              {/* Qualities */}
              <div className={"navbar-item nav-link text-left"}>
                <NavLink
                  className={"globalnav__link list-item"}
                  activeClassName={"globalnav--active"}
                  to={"/qualities"}
                  onClick={() => this.props.hideNavbarDropdown()}
                >
                  {"Qualities"}
                </NavLink>
              </div>

              {/* Sustainability */}
              <div className={"navbar-item nav-link text-left"}>
                <NavLink
                  className={"globalnav__link list-item"}
                  activeClassName={"globalnav--active"}
                  to={"/sustainability"}
                  onClick={() => this.props.hideNavbarDropdown()}
                >
                  {"Sustainability"}
                </NavLink>
              </div>

              <div className="navbar-hr-divider invis is-hidden-desktop" />
            </div>
          </div>

          <div
            className={classnames({
              "navbar-hr-divider invis": true,
              "is-hidden-desktop": !this.props.create
            })}
          />

          {/* Collabs dropdown */}
          {/* <div
            className={classnames({
              "navbar-item": true,
              "navbar-create-dropdown": this.props.create,
              "nav-link text-left has-dropdown is-hoverable": !this.props.create
            })}
          >
            <div
              className={classnames({
                "navbar-hr-divider invis": true,
                "is-hidden-desktop": !this.props.create
              })}
            />

            <a
              className={classnames({
                "globalnav__link navbar-link navbar-dropdown-category": true,
                small: this.props.create
              })}
            >
              <NavLink className={"black"} to={"/collabs"}>
                {"Collabs"}
              </NavLink>
            </a> */}

            {/* <div
              className={classnames({
                "navbar-dropdown right": !this.props.create
              })}
            > */}
              {/* SSWTR x Vonnegut/Kraft */}
              {/* <div className={"navbar-item nav-link text-left"}>
                <NavLink
                  className={"globalnav__link list-item"}
                  activeClassName={"globalnav--active"}
                  to={
                    "/collab-artist/slow-and-steady-wins-the-race-vonnegut-kraft/"
                  }
                  onClick={() => this.props.hideNavbarDropdown()}
                >
                  {"SSWTR × Vonnegut/Kraft"}
                </NavLink>
              </div> */}

              {/* John Caserta */}
              {/* <div className={"navbar-item nav-link text-left"}>
                <NavLink
                  className={"globalnav__link list-item"}
                  activeClassName={"globalnav--active"}
                  to={"/collab-artist/john-caserta/"}
                  onClick={() => this.props.hideNavbarDropdown()}
                >
                  {"John Caserta"}
                </NavLink>
              </div> */}

              {/* Julia Dault */}
              {/* <div className={"navbar-item nav-link text-left"}>
                <NavLink
                  className={"globalnav__link list-item"}
                  activeClassName={"globalnav--active"}
                  to={"/collab-artist/julia-dault/"}
                  onClick={() => this.props.hideNavbarDropdown()}
                >
                  {"Julia Dault"}
                </NavLink>
              </div> */}

              {/* Julian Kreimer */}
              {/* <div className={"navbar-item nav-link text-left"}>
                <NavLink
                  className={"globalnav__link list-item"}
                  activeClassName={"globalnav--active"}
                  to={"/collab-artist/julian-kreimer/"}
                  onClick={() => this.props.hideNavbarDropdown()}
                >
                  {"Julian Kreimer"}
                </NavLink>
              </div> */}

              {/* Stefanie Pender */}
              {/* <div className={"navbar-item nav-link text-left"}>
                <NavLink
                  className={"globalnav__link list-item"}
                  activeClassName={"globalnav--active"}
                  to={"/collab-artist/stefanie-pender/"}
                  onClick={() => this.props.hideNavbarDropdown()}
                >
                  {"Stefanie Pender"}
                </NavLink>
              </div> */}

              {/* Kevin Zucker */}
              {/* <div className={"navbar-item nav-link text-left"}>
                <NavLink
                  className={"globalnav__link list-item"}
                  activeClassName={"globalnav--active"}
                  to={"/collab-artist/kevin-zucker/"}
                  onClick={() => this.props.hideNavbarDropdown()}
                >
                  {"Kevin Zucker"}
                </NavLink>
              </div> */}

              {/* <div
                className={classnames({
                  "navbar-hr-divider invis": true,
                  "is-hidden-desktop": !this.props.create
                })}
              />
            </div>
          </div> */}

          <div
            className={classnames({
              "navbar-hr-divider": true,
              "is-hidden-desktop": !this.props.create
            })}
          />

          {this.props.isAuthenticated ? (
            <span
              className={classnames({
                "is-hidden-desktop": !this.props.create
              })}
            >
              <div
                className={classnames({
                  "navbar-item": true,
                  "is-hidden-desktop": !this.props.create
                })}
              >
                <NavLink
                  to={"/account"}
                  className={"globalnav__link"}
                  onClick={() => this.props.hideNavbarDropdown()}
                >
                  {"My Account"}
                </NavLink>
              </div>

              <div
                className={classnames({
                  "navbar-item": true,
                  "is-hidden-desktop": !this.props.create
                })}
              >
                <NavLink
                  to={"/"}
                  onClick={() => {
                    this.props.hideNavbarDropdown();
                    this.props.logoutUser();
                  }}
                  className={"globalnav__link"}
                >
                  {"Sign Out"}
                </NavLink>
              </div>
            </span>
          ) : (
            <div
              className={classnames({
                "navbar-item": true,
                "is-hidden-desktop": !this.props.create
              })}
            >
              <NavLink
                to={"/sign-in"}
                className={"globalnav__link"}
                onClick={() => this.props.hideNavbarDropdown()}
              >
                {"Sign In"}
              </NavLink>

              <div className="navbar-hr-divider invis is-hidden-desktop" />
            </div>
          )}
        </div>

        {/*        <div className={classnames({
          'navbar-end is-hidden-touch': true,
          'hidden': (this.props.create)
        })}>
          <div className={'navbar-item'}>
            <div className={'cart'}>
              <Cart />
            </div>
          </div>
        </div>*/}
      </nav>
    );
  }
}

function mapStateToProps(state) {
  return {
    hasPro: state.user.pro_subscription,
    isAuthenticated: state.user.isAuthenticated,
    navbarDropdownVisible: state.user.navbarDropdownVisible
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ ...shopActions, ...userActions }, dispatch);
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(onClickOutside(GlobalNav));
